<!-- 新增收货地址页 -->
<template>
 
    <div class="wrap">
      <div class="inputForm_info">
         <div class="telDiv">
          <span>用户昵称：</span>
           <input type="text" placeholder="请输入用户昵称" v-model="user.nickname">
        </div>

        <div class="telDiv telDiv_01">
          <span>手机号：</span>
          <div @click="() => showDio = true">
            <span >{{ user.mobile ? user.mobile : '去绑定' }}</span>
            <span></span>
          </div>
        </div>
 
        <div class="telDiv">
          <span>性别：</span>
          <select v-model="user.gender">
            <option value="0">保密</option>
            <option value="1" selected>男</option>
            <option value="2">女</option>
          </select>
        </div>

        <div class="telDiv">
          <span>身份证号：</span>
          <input type="text" placeholder="请输入身份证号" v-model="user.userIdCard">
        </div>

        <div class="telDiv">
          <span>年龄：</span>
         <input type="number" placeholder="请输入年龄" v-model="user.age">
        </div>
      </div>
      <div class="loginBtn" @click="keepSave" :style="{background: `${colourName}`}">保存信息</div>

      <Bounced type='confirm' @took='queRenOk' @tocancel='() => showDio = false' :showstate='showDio' >
        <span slot='tlt'>提示</span>  <div slot='text'>确定要修改手机号么?</div>
      </Bounced>
    </div>
      
</template>

<script>
 import * as api from '@/api'
 import JmmToast from '@/components/JmmToast'
 import Bounced from "@/components/Bounced";
  export default {
    name: 'login',
    data () {
      return {
        colourName: '#FB4E4D',
        showDio: false,     // 模态框
        sign:'',
        token:'',
        user: {},           // 用户信息
      }
    },
    components: { JmmToast, Bounced },
    created() {
      this.merchantId = this.$route.query.merchantId;
      if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
        localStorage.setItem('cityMerchantId', this.merchantId);
      }
      // 色调选择
      this.displayType = localStorage.getItem("displayType");
      if(this.displayType === '0'){
        this.colourName = "#f8992d";
      }
      this.token = this.$route.query.token;
      this.sign = this.$route.query.sign ? this.$route.query.sign : localStorage.getItem('codeSign')
      // if(!localStorage.getItem("codeSign")) {
      //    window.location.href="weblogin.html#/?timeer=66666";  //跳转首页登录
      // };
      // 先获取个人信息页面
      this.fetch();
    },
    computed: {
      styleVar() {
        return {
          '--colourName': this.colourName
        }
      }
    },
    methods: {
     queRenOk: function () {
       window.location.href = `h5cardlogin.html#/?editPhone=${this.user.mobile}`
       this.showDio = false
    },
        async fetch(){
          let _this = this;
          try{
            let testToken = 'jjcimpilpgejfeehkdinjlbgabbgchhe';
            localStorage.setItem('reToken', _this.token ? _this.token : testToken);

            let info = { sign: this.sign }
            const res = await api.user.userInfo(info);
            // alert(JSON.stringify(res) + "个人信息==")
            if (res.code == "000000") {
              this.user = res.data
            } else {
              JmmToast(res.message)
            }
          } catch (err) {
            console.log(err);
          }
        },
        // 修改的值 是用户修改那个就做校验
        async keepSave(){
          if (this.user.nickname) {
            let nameCheck = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
             if (!nameCheck.test(this.user.nickname)) {
               JmmToast('用户昵称只能包含汉字和字母'); return
             }
          }
          if (this.user.userIdCard) {
            let reg1 = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
              if (!reg1.test(this.user.userIdCard)) {
                JmmToast('身份证输入不合法'); return
              }
          }
         
          try{
             let testToken = 'jjcimpilpgejfeehkdinjlbgabbgchhe';
             localStorage.setItem('reToken', this.token ? this.token : testToken);
            let info = {
              sign: this.sign,
              id: this.user.id,
              // mobile: this.user.mobile,
              nickname: this.user.nickname,
              gender: this.user.gender,
              userIdCard: this.user.userIdCard,
              age: this.user.age,
            };
            const res = await api.user.webuserUpdate(info);
            // const res = await api.user.userUpdate(info);
            if (res.code == "000000") {
              JmmToast("修改成功");
              this.fetch()
            } else {
              JmmToast(res.message);
            }
          } catch (err) {
            console.log(err);
          }
        },
    },
   
  }
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'

.wrap{
   width :100%;
   height :100%;
   overflow :hidden;
   background :#f5f5f5;
}

.wrap .inputForm_info{
   background:#fff;
   padding: 20px 0;
}

.wrap .inputForm_info .telDiv{
  width:calc(100% - 150px);
  margin-left:auto;
  margin-right :auto;
  height:110px;
  border-bottom:1px solid #ddd;
  display:flex;
}
.wrap .inputForm_info .telDiv:last-child{
  border-bottom: none;
}

 .loginBtn{
   width:calc(100% - 150px);
   height:90px;
   line-height:90px;
   background: var(--colourName);
   border-radius:45px;
   font-size:34px;
   text-align:center;
   color:$color;
   left:0;
   right:0;
   bottom:40px;
   margin:auto;
   position: absolute;
}

.wrap .inputForm_info .telDiv input{
    width:calc(100% - 60px);
    text-align:right;
    height: 80px;
    font-size: 30px;
    margin-top 15px;
   
}

.wrap .inputForm_info .telDiv input::-webkit-input-placeholder{ /*WebKit browsers*/

font-size :26px;
line-height :36px;

}

.wrap .inputForm_info .telDiv input::-moz-input-placeholder{ /*Mozilla Firefox*/

font-size :26px;
line-height :36px;

}

.wrap .inputForm_info .telDiv input::-ms-input-placeholder{ /*Internet Explorer*/ 

font-size :26px;
line-height :36px;

}


.wrap .inputForm_info .telDiv span{
     display:inline-block;
     float:left;
     align-self:center;
     width:200px; 
     font-size: 30px;
     
}

.wrap .inputForm_info .telDiv_01, .wrap .inputForm_info .telDiv_01 div {
    display flex
    justify-content space-between
    align-items center
}

.wrap .inputForm_info .telDiv_01 div span:first-child{
    font-size: 26px;
}
.wrap .inputForm_info .telDiv_01 div span:last-child{
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-left: 20px solid #666;
    border-bottom: 10px solid transparent;
}

.wrap .inputForm_info .telDiv select {
    margin-left:calc(100% - 240px);
    width:110px;
    height:80px;
    background-color: none;
    text-align:right;
    font-size: 30px;
    margin-top 15px;
    outline: none;
    border: none;
}

.clearBoth{
 clear:both;  
}
  
.leftRouter{
 float:$floLeft
}
 
.rightRouter{
 float:$florRight
}

</style>



// WEBPACK FOOTER //
// src/view/h5info/index.vue